(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("AddRegistrantsCtrl", ["learningItemSeminarsResource", "data", "$scope", "messageService", "DTOptionsBuilder", "$translate", "$timeout", "$compile", "$filter", "$q", "_", addRegistrantsCtrl]);
    function addRegistrantsCtrl(learningItemSeminarsResource, data, $scope, messageService, DTOptionsBuilder, $translate, $timeout, $compile, $filter, $q, _) {
        var vm = this;
        vm.selectedLearners = [];
        vm.dtInstance = {};
        vm.lang = $translate.proposedLanguage() || $translate.use();
        vm.model = [];
        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            return $q(function (resolve) {
                learningItemSeminarsResource.getAssignedLearners({ id: data.seminarId, lastName: "999", firstName: "999" }, function (data) {
                    vm.model = _.map(data, function (item) {
                        item.added = false;
                        return item;
                    });
                    resolve(_.where(data, { enrolled: false }));
                });
            });
        })
            .withOption("createdRow", function (row, data) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
            row.id = data.registrationNumber;
        })
            .withOption("headerCallback", function (header) {
            if (!vm.headerCompiled) {
                // Use this headerCompiled field to only compile header once
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        })
            .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
            .withOption("processing", true)
            .withOption("responsive", { details: { type: "column" } })
            .withOption("order", [1, "desc"])
            .withPaginationType("full_numbers")
            .withBootstrap();
        vm.dtColumns = [
            { "data": null, "defaultContent": "", "class": "control", "orderable": false, "targets": 0 },
            {
                "render": function (_data, _type, full) {
                    var image = "<div class='image' style='float:left;width:34px;height:34px;margin:0 10px 0 0; border-radius:50%;'>";
                    if (!full.profileImageUrl)
                        image = image + "<span class='default-admin-picture'>" + full.name[0] + "</span>";
                    else
                        image = image + "<img style='float:left;width:34px;height:34px;margin:0 10px 0 0; border-radius:50%;' ng-src='" + full.profileImageUrl + "' />";
                    image = image + "</div>";
                    return "<div>" + image
                        + "<div class='p-l-50'>"
                        + full.name
                        + "<br /><small>(" + full.registrationNumber + ")</small>"
                        + "</div>"
                        + "</div>";
                },
                "title": $translate.instant("common.lists.learner"),
                "class": "p-l-20"
            },
            {
                "data": "enrolled",
                "class": "text-center",
                "orderable": false,
                "render": function (data) {
                    return "<div class='f-s-18'>" + $filter("checkboxIcon")(data) + "</div>";
                },
                "sortable": false,
                "title": $translate.instant("common.lists.enrolled")
            },
            {
                "data": null,
                "render": function (_data, _type, full) {
                    if (full.added)
                        return "<label class='text-success' translate='common.added'></label>";
                    return "<button class='btn btn-success' ng-click=\"vm.add($event, \'" + full.registrationNumber + "\'," + full.number + "," + full.version + ")\" translate='common.add'></button>";
                },
                "sortable": false,
                "class": "text-center"
            }
        ];
        vm.dtInstanceCallback = function (instance) {
            vm.dtInstance = instance;
        };
        vm.search = function () {
            if (vm.form.$valid) {
                if (vm.loading)
                    return;
                vm.loading = true;
                learningItemSeminarsResource.getAssignedLearners({ id: data.seminarId, firstName: vm.firstname, lastName: vm.lastname }, function (data) {
                    vm.loading = false;
                    vm.model = _.map(data, function (item) { item.added = false; return item; });
                    vm.filterLearners();
                    //resolve(_.where(data, { enrolled: false }));
                }, function () {
                    vm.loading = false;
                });
            }
            else {
                vm.showErrors = true;
            }
        };
        vm.updateData = function (data) {
            vm.dtInstance.changeData($q(function (resolve) {
                resolve(data);
            }));
        };
        vm.filterLearners = function () {
            vm.showResults = true;
            if (vm.showAll)
                vm.updateData(vm.model);
            else {
                vm.updateData(_.where(vm.model, { enrolled: false }));
            }
        };
        vm.add = function (btn, registrationNumber, number, version) {
            //EXAMPLE Disable button in repeater on click
            if (btn.target.disabled)
                return;
            btn.target.disabled = true;
            learningItemSeminarsResource.addLearnerToSeminar({ id: data.seminarId }, { personSeq: registrationNumber, number: number, version: version, code: data.code }, function () {
                vm.model.forEach(function (e) {
                    if (e.registrationNumber === registrationNumber && e.number === number && e.version === version) {
                        e.enrolled = true;
                        e.added = true;
                    }
                });
                vm.page = vm.dtInstance.DataTable.page();
                vm.updateData(vm.model);
                $timeout(function () {
                    vm.dtInstance.DataTable.page(vm.page).draw(false); //put the table back to the page it was on
                    //vm.dtInstance.DataTable.search(vm.dtSearch).draw(false); //apply the filter again if there was one;
                }, 3);
            }, function (error) {
                messageService.error(error);
            });
        };
    }
}());
